<template>
  <div class="Breadcrumb">
    <Breadcrumb>
      <BreadcrumbItem v-for="item in routerlist" :key="item.name" :to="item.to" :target="item.target">
        {{ item.name }}
      </BreadcrumbItem>
    </Breadcrumb>
  </div>
</template>

<script>
export default {
  name: "MyBrand",
  props: {
    routerlist: {
      type: Array,
    },
  },
};
</script>
<style lang="less" scoped>
.Breadcrumb{
  padding-top: 40px;
}
</style>
